export enum EnumFlyingNicheSize {
	Small 			= 'small',
	Large 			= 'large'
}

export enum EnumFlyingQuoteType {
	Puns			= 'puns',
	Quotes			= 'quotes',
	Sayings			= 'sayings',
	Jokes			= 'jokes',
	Rhymes2Words	= 'rhymes_2_words',
	Rhymes3Words	= 'rhymes_3_words',
	Memes			= 'memes'
}
